import * as routerNames from '@/services/router/router.names'

import UserRegistrationComplete from '@/screens/user-registration/user-registration-complete.vue'

export default [
  {
    path: '/registration/user/complete',
    name: routerNames.USER_REGISTRATION_COMPLETE,
    component: UserRegistrationComplete,
  },
]
